const routerHistory = {
  fromPath: "",
};
export default routerHistory;
